import { Numeric8BoxIcon } from './Numeric8BoxIcon';

/**
 * author: Google
 * id 863E0667-F376-4303-9261-CAA4B7F073C6
 * name numeric-8-box
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-8-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const Number8BoxIcon = Numeric8BoxIcon;
export default Number8BoxIcon